import { Component } from '@angular/core';
import { BoardService } from '../../services';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector:'board-preview',
  templateUrl: 'preview.html'
})
export class BoardPreviewComponent {
  
  bbsId:number;
  cntntId:number;
  contentHtml: string;

  constructor(private route: ActivatedRoute, private boardService:BoardService, private router:Router) {
  }

  ngOnInit() {
    this.route.params.subscribe(params => {
      if(params['cntntId']) {
        this.cntntId = params['cntntId'];
        this.bbsId = params['bbsId'];
        this.boardService.getBoardContentDetail(this.bbsId, this.cntntId).subscribe(
          resp => {
            this.contentHtml = resp.data.contentDetail.content;
          }
        )
      }
    }); 
  }

  handleClickToList() {
    this.router.navigate(['board', 'list', this.bbsId]);
  }

  
}


// WEBPACK FOOTER //
// ./src/app/containers/board/preview.ts